/* Next10 — botao de fechar do menu mobile.
   Roda na fase de captura para nao cair no handler padrao do Dawn,
   que fecha apenas o submenu e deixaria o body travado. */
document.addEventListener(
  'click',
  function (event) {
    if (!event.target.closest) return;
    var botao = event.target.closest('.n10-drawer__close');
    if (!botao) return;

    var drawer = botao.closest('header-drawer, menu-drawer');
    if (!drawer || typeof drawer.closeMenuDrawer !== 'function') return;

    event.preventDefault();
    event.stopPropagation();
    drawer.closeMenuDrawer(event, drawer.querySelector('summary'));
  },
  true
);

/* Película que travava o site depois de fechar o menu.
   O véu escuro é o ::before do botão do menu, desenhado pelo base.css enquanto
   ele tem aria-expanded="true". O closeMenuDrawer do Dawn só devolve "false"
   quando o fechamento vem do teclado (Esc); no clique do próprio ícone quem
   corrige é o listener global de <summary>. Os fechamentos do tema — o X do
   menu (acima) e o carrinho abrindo por cima do menu (cart-drawer.js) — passam
   um clique/evento comum, então o botão ficava "aberto": o véu cobria a página
   e tocar nele reabria o menu. Aqui todo fechamento real reseta o atributo. */
customElements.whenDefined('header-drawer').then(function () {
  var Drawer = customElements.get('header-drawer');
  var proto = Drawer && Drawer.prototype;
  if (!proto || proto.__n10FechaVeu || typeof proto.closeMenuDrawer !== 'function') return;
  proto.__n10FechaVeu = true;

  var fecharOriginal = proto.closeMenuDrawer;
  proto.closeMenuDrawer = function (event, elementToFocus) {
    var resultado = fecharOriginal.apply(this, arguments);
    /* mesmas condições em que o Dawn realmente fecha */
    if (event !== undefined && elementToFocus) {
      var toggle = this.mainDetailsToggle || this.querySelector('details');
      var summary = toggle && toggle.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }
    return resultado;
  };
});
